var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import React from 'react';
import { MOBILE_SIZE } from '../util/theme';
export var ExpandMore = styled(function (props) {
    var expand = props.expand, other = __rest(props, ["expand"]);
    return _jsx(IconButton, __assign({}, other));
})(function (_a) {
    var theme = _a.theme, expand = _a.expand;
    return ({
        transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    });
});
export var Root = styled('div')(function (_a) {
    var theme = _a.theme;
    return (__assign({ width: '100%', marginTop: '10px' }, theme.typography.body2));
});
export var ButtonBox = styled('div')(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            display: 'flex',
            justifyContent: 'center',
            gap: theme.spacing(1),
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
            flexDirection: 'row',
            alignItems: 'center'
        },
        _b[theme.breakpoints.down(MOBILE_SIZE)] = {
            flexDirection: 'column',
            alignItems: 'stretch',
        },
        _b);
});
export var shouldDisplay = function (value) {
    if (value === 'Não informado' || value === null || value === undefined) {
        return false;
    }
    if (value instanceof Date) {
        return !isNaN(value.getTime());
    }
    return value !== '';
};
